const INITIAL_STATE = {
  ativos: [],
  pagination: {
    page: 1,
    itemsPerPage: 15,
    totalItems: 0
  },
  search: {
    ref: ''
  }
}

export default function favoriteAtivosReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'FAVORITE_ATIVOS_SET_ATIVOS':
      return {
        ...state,
        ativos: action.payload
      }
    case 'FAVORITE_ATIVOS_SET_PAGE':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: action.payload
        }
      }
    case 'FAVORITE_ATIVOS_SET_ITEMS_PER_PAGE':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          itemsPerPage: action.payload
        }
      }
    case 'FAVORITE_ATIVOS_SET_TOTAL_ITEMS':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          totalItems: action.payload
        }
      }
    case 'FAVORITE_ATIVOS_SET_REF':
      return {
        ...state,
        search: {
          ...state.search,
          ref: action.payload
        }
      }
    case 'FAVORITE_ATIVOS_CLEAR_ALL':
      return {
        ...state,
        ...INITIAL_STATE
      }
    default:
      return state
  }
}
